export const APPLY_FORM_LINK =
  'https://docs.google.com/forms/d/e/1FAIpQLScF57IqqE0DBEvx82vPTfJdH3_bJZJcWl4o_xmi7OPa8yiQYA/viewform?usp=sf_link'
export const RAZORPAY_LINK = 'https://rzp.io/l/devsnest'
